import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useEffect } from 'react';
import { SideMenuPages } from '@/components/modules/Layout/SideMenu/SideMenuPages';
import { PageHead } from '@/components/modules/Typography/head/PageHead';
import { ContentContainer } from '@/components/ui/Layout/ContentContainer';
import { textColors } from '@/components/ui/Typography/Body/Text';
import { scrollToWithHeaderHeight } from '@/helpers/ScrollUtils';
import { useLocation } from '@/hooks/lib/react-router/useLocation';
import { usePageLoadStatus } from '@/hooks/lifecycle/usePageLoadStatus';
import { useStaticPageHtmlParser } from '@/hooks/pages/static/useStaticPageHtmlParser';
export const StaticPageView = (props) => {
    const { activePath, className = '', headEnglishText, headText, html } = props;
    /** ハッシュの値 */
    const { hash } = useLocation();
    /** 読み込み状態 */
    const loaded = usePageLoadStatus();
    /**
     * 該当項目にスクロール
     * @description ハッシュに指定された項目にスクロール
     */
    useEffect(() => {
        if (hash && loaded) {
            scrollToWithHeaderHeight(`item_${hash.replace('#', '')}`);
        }
    }, [hash, loaded]);
    const content = useStaticPageHtmlParser({ html });
    return (_jsxs("div", Object.assign({ className: className }, { children: [_jsx(PageHead, { bgImageType: 'building', englishText: headEnglishText, text: headText }), _jsx("div", Object.assign({ className: clsx('pt-40 lg:pt-64', 'pb-64 lg:pb-80') }, { children: _jsxs(ContentContainer, Object.assign({ className: clsx('flex flex-col', 'lg:flex-row-reverse', 'mx-auto', 'gap-x-64 gap-y-40'), maxWidthPoint: 'xl' }, { children: [_jsx("div", Object.assign({ className: 'flex-grow' }, { children: _jsx("section", Object.assign({ className: clsx('flex flex-col gap-y-16', textColors.base) }, { children: content })) })), _jsx(SideMenuPages, { activePath: activePath, className: clsx('shrink-0 w-full lg:w-[270px]') })] })) }))] })));
};
